import { render, staticRenderFns } from "./UserActualPets.vue?vue&type=template&id=2473fc6a&scoped=true&"
import script from "./UserActualPets.vue?vue&type=script&lang=js&"
export * from "./UserActualPets.vue?vue&type=script&lang=js&"
import style0 from "./UserActualPets.vue?vue&type=style&index=0&id=2473fc6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473fc6a",
  null
  
)

export default component.exports